import {DataListModel} from "../interface";
import {UserModel} from "./user.model";

export class UsersModel extends DataListModel {
  items: UserModel[] = [];
}
